'use strict';

window.cdStripe = cdPay;

angular
  .module('cdPay', [
    // external dependencies
    'ngSentry',
    'LocalStorageModule',
    'ui.router',
    'ui.router.state.events',
    'ngMessages',
    'ngSanitize',
    'angularMoment',
    'angularPayments',
    'toastr',
    'gettext',
    'isoCurrency',
    'tmh.dynamicLocale',
    'cdValidateCpr',
    'cdStripe',

    // internal dependencies
    'cdPay.components',
    'cdPay.directives',
    'cdPay.filters',
    'cdPay.models',
    'cdPay.providers',
    'cdPay.routes',
    'cdPay.templates',
  ])

  .constant('cdPay', cdPay)
  .run(($rootScope) => ($rootScope.cdPay = cdPay))

  .constant('_', window._)
  .run(($rootScope) => ($rootScope._ = window._))

  .constant('moment', window.moment)
  .run(($rootScope) => ($rootScope.moment = window.moment))

  .constant('swal', window.swal)
  .run(($rootScope) => ($rootScope.swal = window.swal))

  .config(($compileProvider) => $compileProvider.debugInfoEnabled(false))
  .config(($locationProvider) => $locationProvider.html5Mode(true))
  .config((tmhDynamicLocaleProvider) =>
    tmhDynamicLocaleProvider.localeLocationPattern(
      'https://cdnjs.cloudflare.com/ajax/libs/angular-i18n/{{angularVersion}}/angular-locale_{{locale}}.min.js'
    )
  )
  .config((localStorageServiceProvider) =>
    localStorageServiceProvider.setPrefix('churchdesk')
  )

  .run(() => {
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (string, position = 0) {
        return this.indexOf(string, position) === position;
      };
    }
  })

  // Extract a set of country data from the intlTelInput and assign custom array
  // of countries with translated names to a global object so it can be used wherever it's needed
  // TODO: Refactor this into a constant or service instead
  .run(($timeout, gettextCatalog, _) => {
    let countries = {};

    try {
      countries = _($.fn.intlTelInput.getCountryData())
        .groupBy('iso2')
        .mapValues((item) => item[0])
        .value();

      _.set(cdPay, 'data.countries', countries);
    } catch (e) {
      // empty
    }
    $timeout(() => {
      _.mapValues(countries, (country) => {
        var base = country.name.split(' (')[0];

        return _.extend(country, {
          nameEnglish: base,
          nameTranslated: gettextCatalog.getString(base),
          nameTranslatedFull: `${gettextCatalog.getString(base)} (${base})`,
        });
      });
    });
  })

  .config(($stateProvider, $urlRouterProvider) => {
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('home', {
        url: '/:id',
        component: 'home',
      })
      .state('notFound', {
        path: '/:id/**',
        component: 'notFound',
        params: {
          errorCode: null,
        },
        resolve: {
          errorCode: ($stateParams) => $stateParams.errorCode,
        },
      });
  });
